import type { TypedDocumentNode } from '@apollo/client';
import { gql, useMutation } from '@apollo/client';

import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

import type {
  UpdateUserSettingsCurrencyMutation,
  UpdateUserSettingsCurrencyMutationVariables,
} from './__generated__/useUpdateCurrency.graphql.ts';

const UPDATE_USER_SETTINGS_CURRENCY_MUTATION = gql`
  mutation UpdateUserSettingsCurrencyMutation(
    $input: updateUserSettingsInput!
  ) {
    updateUserSettings(input: $input) {
      userSettings {
        id
        currency
        fiatCurrency
      }
      errors {
        path
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  UpdateUserSettingsCurrencyMutation,
  UpdateUserSettingsCurrencyMutationVariables
>;

export const useUpdateCurrency = () => {
  const { currentUser } = useCurrentUserContext();
  const [mutateCurrency, { loading }] = useMutation(
    UPDATE_USER_SETTINGS_CURRENCY_MUTATION
  );

  const updateCurrency = (target: string) => (value: string) => {
    mutateCurrency({
      variables: {
        input: {
          [target]: value,
        },
      },
      optimisticResponse: {
        updateUserSettings: {
          __typename: 'updateUserSettingsPayload',
          userSettings: {
            ...currentUser!.userSettings,
            [target]: value,
          },
          errors: [],
        },
      },
    });
  };

  return {
    updateCurrency,
    loading,
  };
};
